<style>
  .import-validation-kendo-grid {

  overflow-x: auto !important;
  /* Set the desired height for the scrollable container */
  height: calc(40vh - 5px);
  overflow-y: auto !important;  /*Enable vertical scrolling */
  margin-bottom: 45px;
}
.import-validation-kendo-grid .k-header {
width: 200px;
}


.import-validation-kendo-grid .k-grid-header { position: sticky; top: 0; z-index: 100;
}
td {
width: 100%
}

.k-datepicker.k-input
{
width:80%;
}
.showErrorCheckBoxClass:hover {
cursor:pointer;
}
.imp-cell-error {
background-color: #f8d7da;
color: #721c24;
padding: 2px 4px;
border-radius: 2px;
}
</style>
<form novalidate [formGroup]="gridFileds">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <p class="step_title">Step 4:</p>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 paddingFull">
        <div class="container_box">
          <div class="margin_button_20">
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <div class="row">
                <div class="col-10 import-title-header">Total Line Items:</div>
                @if (_gridView) {
                  <div class="col-2 font-weight-bold fcdarkmode">
                    {{_gridView.total}}
                  </div>
                }
              </div>

              <div class="row">
                <div class="col-10 import-title-header">Available:</div>
                @if (_gridView) {
                  <div class="col-2 text-success font-weight-bold">
                    {{_gridView.total - getErrorsCount(_dataToImport)}}
                  </div>
                }
              </div>

              <div class="row">
                <div class="col-10 import-title-header">Problem:</div>
                <div class="col-2 text-danger font-weight-bold">{{getErrorsCount(_dataToImport)}}</div>
              </div>
            </div>
          </div>

          <kendo-grid #grid class="import-validation-kendo-grid" [data]="_gridView" [pageSize]="_pageSize" [skip]="_skip"
            [pageable]="false" [selectable]="true" [kendoGridSelectBy]="'Id'" (pageChange)="_pageGridChange($event)"
            (cellClick)="_cellClickHandler($event)" (cellClose)="_cellCloseHandler($event)"
            (cancel)="_cancelHandler($event)" (save)="_saveHandler($event)" (remove)="_removeHandler($event)"
            (select)="onSelect($event)"
            [selectedKeys]="_indexToBeRemoved"
            (add)="_addHandler($event)" (selectedKeysChange)="_onSelectedKeysChange($event)" (selectionChange)="_onSelectionChange($event)" [resizable]="true"
            (keydown)="onKeyDown($event)">
            <ng-template kendoGridToolbarTemplate>

              <button [disabled]="showErrorsOnly == true" kendoGridAddCommand>Add New Row</button>
              <button class="k-button" [disabled]="!_hasChanges" (click)="_cancelChanges(grid);">
                Cancel Changes
              </button>
              <button class="k-button" [disabled]="!selectedItemsEnable" (click)=_removeBatch()> Remove Batch</button>
              <!-- <input type="checkbox" [(ngModel)]="showErrorsOnly" [ngModelOptions]="{standalone: true}"
              (click)="showErrorCheckBoxClicked()"> Show Errors Only -->

              <div class="row zeromarginRow">
                <div class="col-12 zeroPaddingColumn">
                  <div class="col-12 zeroPaddingColumn">
                    <input type="checkbox" class="k-checkbox"
                      id="showErrorsOnly"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="showErrorsOnly"
                      (ngModelChange)="showErrorCheckBoxClicked()"
                      kendoCheckBox />
                      <label class="control-label showErrorCheckBoxClass" for="showErrorsOnly">Show Errors Only
                      </label>
                    </div>
                  </div>
                </div>
              </ng-template>


              <kendo-grid-checkbox-column field="isChecked" [width]="50" [showSelectAll]="true">
              </kendo-grid-checkbox-column>
              <!-- [field]="field.fieldName ? (field.name + '.' + field.fieldName) : field.name" -->
              <!-- [field]="field.name" -->
              @for (field of _gridColumnsName; track field) {
                @if (!field.entity || field.entity == 'customFieldsValue') {
                  <kendo-grid-column
                    [width]="200"
                    [title]="field.mappedName"
                    [field]="field.name"
                    [editor]="field.type" title="{{field.label}}" [editable]="field.name != 'Error'"
                    [headerStyle]="{'font-weight': 'bold'}"
                    [class]="field.name != 'Error' ? 'fiealdscolor' : 'fiealdscolorError'"
                    >
                    <!-- [style]="field.name != 'Error' ? {'color': '#212529'} : {'color': '#dc3545'}"> -->
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span [class.imp-cell-error]="cellHasError(field, dataItem)">{{ getCellValue(field, dataItem) }}</span>
                    </ng-template>
                  </kendo-grid-column>
                }
                @if (field.entity && field.entityRelation == 'OneToOne') {
                  <kendo-grid-column
                    [width]="200"
                    [title]="field.mappedName"
                    [field]="!field.fieldName ? (field.entity + '.' + field.name ) : (field.entity + '.' + field.name + '.' + field.fieldName )"
                    [editor]="field.type" title="{{field.label}}" [editable]="field.name != 'Error'"
                    [headerStyle]="{'font-weight': 'bold'}"
                    [class]="field.name != 'Error' ? 'fiealdscolor' : 'fiealdscolorError'">
                    <!-- [style]="field.name != 'Error' ? {'color': '#212529'} : {'color': '#dc3545'}"> -->
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span [class.imp-cell-error]="cellHasError(field, dataItem)">{{ getCellValue(field, dataItem) }}</span>
                    </ng-template>
                  </kendo-grid-column>
                }
                <!-- [field]="field.entity" -->
                @if (field.entity && field.entityRelation == 'OneToMany') {
                  <kendo-grid-column
                    [width]="200"
                    [title]="field.mappedName"
                    [field]="!field.fieldName ? ('TempArray ' + field.entity + '.' + field.name ) : ('TempArray ' + field.entity + '.' + field.name + '.' + field.fieldName )"
                    [editor]="field.type" title="{{field.label}}" [editable]="field.name != 'Error'"
                    [headerStyle]="{'font-weight': 'bold'}"
                    [class]="field.name != 'Error' ? 'fiealdscolor' : 'fiealdscolorError'">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <!-- {{field.type}} -->
                      {{field.fieldName ? (dataItem['TempArray ' + field.entity][field.name][field.fieldName] ) : (dataItem['TempArray ' + field.entity][field.name] ) | json }}
                      <!-- <input type="text"  [ngModelOptions]="{standalone: true}" [(ngModel)]="field.fieldName ? dataItem[field.entity][0][field.name][field.fieldName]  : dataItem[field.entity][field.name]"/> -->
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      @for (item of dataItem[field.entity]; track item; let i = $index) {
                        <span >
                          <!-- <input type="text"  [ngModelOptions]="{standalone: true}" [(ngModel)]="field.fieldName ? item[field.name][field.fieldName]  : item[field.name]"/> -->
                          <!-- {{field.fieldName ? (item[field.name][field.fieldName] ) : (item[field.name] ) | json }} -->
                        </span>
                      }
                    </ng-template>
                    <!-- <ng-template kendoGridEditTemplate let-dataItem>
                    <span [formArrayName]="field.entity"  *ngFor="let item of field.entity.controls; let i = index">
                      <span [formGroupName]="i">
                        <label
                          [formControlName]="field.fieldName ? (item[field.name][field.fieldName] ) : (item[field.name] )">
                        </label>
                        {{field.fieldName ? (item[field.name][field.fieldName] ) : (item[field.name] ) | json }}
                        <kendo-textbox
  [formControlName]="field.fieldName ? item[field.name][field.fieldName]
  : item[field.name]">
                        </kendo-textbox>
                      </span>
                    </span>
                  </ng-template> -->
                </kendo-grid-column>
              }
            }
            <kendo-grid-command-column title="command" [width]="220" [headerStyle]="{'font-weight': 'bold'}">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button kendoGridRemoveCommand>Remove</button>
                <button kendoGridSaveCommand>Add</button>
                <button kendoGridCancelCommand>Cancel</button>
              </ng-template>
            </kendo-grid-command-column>
          </kendo-grid>



        </div>
      </div>
    </div>
  </div>
</form>
